import React from "react";
import { BoxDanger, MnemoLoading, MSection } from "components/misc";
import { Row, Col } from "design-react-kit";
import { learningService, networkErrorHelper } from "libs";

export class BandiEvaluationGrid extends React.Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      loading: false,
      bandoEdition: props.bandoEdition || 1,
      aa: props.aa || "2025",
      company: props.company || "",
      remotePayload: [],
      payloadGrouped: [],
    };
  }

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote = () => {
    this.setState({ loading: true });

    const { bandoEdition, aa, company } = this.state;
    learningService
      .getBandiEvaluationByBandoEdition(company, bandoEdition, aa)
      .then((response) => {
        const groupedMap = new Map();

        response.data.payload.evaluationBando.forEach((item) => {
          const key = `${item.competitionClass}_${item.bandoedition}`;
          if (!groupedMap.has(key)) {
            groupedMap.set(key, {
              competitionClass: item.competitionClass,
              title: item.title,
              info: [],
            });
          }
          groupedMap.get(key).info.push(item);
        });

        const result = Array.from(groupedMap.values());

        this.setState({
          loading: false,
          remotePayload: response.data.payload.evaluationBando,
          payloadGrouped: result,
        });
      })
      .catch((error) => {
        let errorMessage = "";
        let networkError = false;
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
          errorMessage = networkErrorHelper.getErrorMessage(error);
          networkError = true;
        }

        this.setState({
          networkError: networkError,
          errorMessage: errorMessage,
          error: error,
          loading: false,
        });
      });
  };

  render() {
    let { loading, payloadGrouped } = this.state;
    if (loading) return <MnemoLoading />;
    //--- ---
    return (
      <>
        <MSection className="mb-5">
          <Row>
            <Col>
              {payloadGrouped.length > 0 ? (
                <>
                  <ul>
                    <li>
                      risultano <b>AMMESSI</b> i seguenti: Riservista 45% -
                      allegato 2; Regolare 55% - allegato 1; Riservista 5%;
                    </li>
                    <li>
                      risultano <b>NON ammessi seguenti:</b> Escluso Regolare;
                      Escluso Riservista
                    </li>
                  </ul>
                  
                  {payloadGrouped.map((item, index) => (
                    <div key={index} className="mb-2">
                      <h5>
                        {item.competitionClass} - {item.title}
                      </h5>
                      <ul>
                        {item.info.map((infoItem, infoIndex) => (
                          <>
                            {(infoItem.url) && (
                              <li key={infoIndex}><a href={infoItem.url} target="_blank" rel="noopener noreferrer">{infoItem.region} - {infoItem.company}</a></li>
                            )}
                          </>
                        ))}
                      </ul>
                    </div>
                  ))}
                </>
              ) : (
                <BoxDanger>
                  La ricerca non ho prodotto alcun risultato.
                </BoxDanger>
              )}
            </Col>
          </Row>
        </MSection>
      </>
    );
  }
}
